// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_commonapis__Buhta_common_v1_grid from "../../../proto/commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_core__Tenant from "./Tenant.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../vendored/promise/promise.js";
import * as ReasonReactUpdate from "../../../vendored/reason-react-update/ReasonReactUpdate.js";
import * as Stdlib from "melange/stdlib.js";

function makeGridRequest(params, unit) {
  if (params === undefined) {
    return Curry._6(Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest.make, undefined, undefined, undefined, undefined, undefined, undefined);
  }
  const search = Belt__Belt_Option.map(params.search, (function (query) {
          return Curry._2(Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest.Search.make, query, undefined);
        }));
  const filters = Belt__Belt_List.map(params.filters, (function (f) {
          return Curry._3(Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest.Filter.make, f.name, f.value, undefined);
        }));
  const paginate = Curry._3(Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest.Pagination.make, params.page, undefined, undefined);
  return Curry._6(Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest.make, search, filters, paginate, undefined, params.expand, undefined);
}

function useModel($$fetch, param) {
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const match$1 = ReasonReactUpdate.useReducer("Loading", (function (action, param) {
          const variant = action.NAME;
          if (variant === "Fetch") {
            return {
                    TAG: /* UpdateWithSideEffects */1,
                    _0: "Loading",
                    _1: (function (param) {
                        const send = param.send;
                        const __x = Curry._2($$fetch, tenant, undefined);
                        $$Promise.get(__x, (function (res) {
                                if (res.TAG === /* Ok */0) {
                                  return Curry._1(send, {
                                              NAME: "Fetched",
                                              VAL: res._0
                                            });
                                } else {
                                  return Curry._1(send, {
                                              NAME: "Failed",
                                              VAL: res._0
                                            });
                                }
                              }));
                      })
                  };
          } else if (variant === "Failed") {
            return {
                    TAG: /* Update */0,
                    _0: {
                      NAME: "Error",
                      VAL: action.VAL
                    }
                  };
          } else {
            return {
                    TAG: /* Update */0,
                    _0: {
                      NAME: "Data",
                      VAL: action.VAL
                    }
                  };
          }
        }));
  const dispatch = match$1[1];
  const dispatcher = function (tenant, param) {
    Curry._1(dispatch, {
          NAME: "Fetch",
          VAL: undefined
        });
  };
  return [
          match$1[0],
          dispatcher
        ];
}

function useGrid($$fetch, param) {
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const match$1 = ReasonReactUpdate.useReducer("Loading", (function (action, param) {
          const variant = action.NAME;
          if (variant !== "Fetch") {
            if (variant === "Failed") {
              return {
                      TAG: /* Update */0,
                      _0: {
                        NAME: "Error",
                        VAL: action.VAL
                      }
                    };
            } else {
              return {
                      TAG: /* Update */0,
                      _0: {
                        NAME: "Data",
                        VAL: action.VAL
                      }
                    };
            }
          }
          const params = action.VAL;
          return {
                  TAG: /* UpdateWithSideEffects */1,
                  _0: "Loading",
                  _1: (function (param) {
                      const send = param.send;
                      const __x = Curry._3($$fetch, tenant, params, undefined);
                      $$Promise.get(__x, (function (res) {
                              if (res.TAG === /* Ok */0) {
                                return Curry._1(send, {
                                            NAME: "Fetched",
                                            VAL: res._0
                                          });
                              } else {
                                return Curry._1(send, {
                                            NAME: "Failed",
                                            VAL: res._0
                                          });
                              }
                            }));
                    })
                };
        }));
  const dispatch = match$1[1];
  const dispatcher = function (tenant, params, param) {
    Curry._1(dispatch, {
          NAME: "Fetch",
          VAL: params
        });
  };
  return [
          match$1[0],
          dispatcher
        ];
}

function unwrapPromiseResult(promise) {
  return $$Promise.map(promise, (function (result) {
                if (result.TAG !== /* Ok */0) {
                  return {
                          TAG: /* Error */1,
                          _0: result._0
                        };
                }
                const response = result._0;
                if (response !== undefined) {
                  return {
                          TAG: /* Ok */0,
                          _0: Caml_option.valFromOption(response)
                        };
                } else {
                  return Stdlib.failwith("Unexpected none response");
                }
              }));
}

function unwrapPromiseResponse(unwrapper, promise) {
  return $$Promise.map(promise, (function (result) {
                if (result.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: Curry._1(unwrapper, result._0)
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: result._0
                        };
                }
              }));
}

export {
  makeGridRequest ,
  useModel ,
  useGrid ,
  unwrapPromiseResult ,
  unwrapPromiseResponse ,
}
/* Buhta_commonapis__Buhta_common_v1_grid Not a pure module */
